// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-image-viewer__canvas img {\n  background-color: #fff;\n}", ""]);
// Exports
module.exports = exports;
